import { render, staticRenderFns } from "./PatientHistoryItemActiveMedication.vue?vue&type=template&id=008b852e&scoped=true&lang=pug&"
import script from "./PatientHistoryItemActiveMedication.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryItemActiveMedication.vue?vue&type=script&lang=js&"
import style0 from "./PatientHistoryItemActiveMedication.vue?vue&type=style&index=0&id=008b852e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b852e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
